import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractTransport } from '../models/abstract-transport.model';

@Injectable({
  providedIn: 'root',
})
export class TransportConstraintsService {
  readonly #translateService = inject(TranslateService);

  private writeSingleTypeOfConstraints(constraints: string, constraintKey: string, inline: boolean = false): string {
    return constraints
      .split('|')
      .reduce(
        (result: string, constraint: string): string =>
          result + (inline ? (result.length ? ' - ' : '') : '<li>') + this.#translateService.instant(constraintKey + constraint.toUpperCase()) + (inline ? '' : '</li>'),
        ''
      );
  }

  public formatConstraints(
    value: AbstractTransport,
    options: {
      pickup?: boolean;
      delivery?: boolean;
      inline?: boolean;
    }
  ): string {
    if (!options.pickup && !options.delivery) {
      return '';
    }
    let result = '';
    if (options.pickup) {
      if (value.pickupAccessConstraint || value.pickupLoadingConstraint) {
        result += options.inline ? '' : '<ul>';
        if (value.pickupLoadingConstraint) {
          result += this.writeSingleTypeOfConstraints(value.pickupLoadingConstraint, 'LOADING_CONSTRAINT.PICKUP_MODE.', options.inline) + ' ';
        }
        if (value.pickupAccessConstraint) {
          result += this.writeSingleTypeOfConstraints(value.pickupAccessConstraint, 'ACCESS_CONSTRAINT.ACCESS_MODE.', options.inline);
        }
        result += options.inline ? ' ' : '</ul>';
      }
    }
    if (options.delivery) {
      if (value.deliveryAccessConstraint || value.deliveryLoadingConstraint) {
        result += options.inline ? '' : '<ul>';
        if (value.deliveryLoadingConstraint) {
          result += this.writeSingleTypeOfConstraints(value.deliveryLoadingConstraint, 'LOADING_CONSTRAINT.DELIVERY_MODE.', options.inline) + ' ';
        }
        if (value.deliveryAccessConstraint) {
          result += this.writeSingleTypeOfConstraints(value.deliveryAccessConstraint, 'ACCESS_CONSTRAINT.ACCESS_MODE.', options.inline);
        }
        result += options.inline ? '' : '</ul>';
      }
    }
    return result;
  }
}
